import { connect } from 'react-redux';
import { showReportModal } from '../../../../Moderation/redux/actions';
import { pushNftLinkPopup } from '../../../../Modals/redux/actionCreators';
import { getIsCurrentUserAuthorOf } from '../../../../redux/deviations/selectors';
import { shareDeviationToPost } from '../../../../redux/deviations/actionCreators';
import { beginDeviationAwardBadgeFlow } from '../../../../coreBadge/redux/actionCreators';
import { expandAndFocusCommentPanel } from '../../../../DeviationPage/redux/actions';
const mapStateToProps = (state, ownProps)=>({
        isOwner: getIsCurrentUserAuthorOf(state, ownProps.deviation)
    });
const mapDispatchToProps = {
    showReportModal,
    shareDeviationToPost,
    showNftLinkPopup: pushNftLinkPopup,
    showAwardBadgePopup: beginDeviationAwardBadgeFlow,
    onToggleCommentPanel: expandAndFocusCommentPanel
};
export default connect(mapStateToProps, mapDispatchToProps);
